import React from "react";
import { ChartNew } from "../../../../../components";

const AreaChartList = () => {
  const renderTooltip = (data) => (
    <div className="flex flex-col gap-3 text-sm">
      <span className="text-primary">{data.label}</span>
      <div className="bg-primary-50 text-gray-600 text-xs font-medium w-[100px] flex justify-between p-2 rounded shadow-md">
        Value: <span className="text-primary">{data.value}</span>
      </div>
    </div>
  );

  return (
    <ChartNew
      type="areachart"
      barColors={[
        { color: "primary" },
        { color: "info" },
        { color: "leave" },
        { color: "draft", depth: 500 },
        { color: "success" },
      ]}
      rawData={[
        { Month: "Jan", Revenue: 60, Invoices: 70 },
        { Month: "Feb", Revenue: 90, Invoices: 70 },
        { Month: "Mar", Revenue: 130, Invoices: 70 },
        { Month: "Apr", Revenue: 125, Invoices: 70 },
        { Month: "May", Revenue: 100, Invoices: 70 },
        { Month: "Jun", Revenue: 145, Invoices: 70 },
        { Month: "Jul", Revenue: 155, Invoices: 70 },
        { Month: "Aug", Revenue: 130, Invoices: 70 },
        { Month: "Sep", Revenue: 105, Invoices: 70 },
        { Month: "Oct", Revenue: 100, Invoices: 70 },
        { Month: "Nov", Revenue: 120, Invoices: 70 },
        { Month: "Dec", Revenue: 160, Invoices: 70 },
      ]}
      chartLabel={"Month"}
      chartValue={"Revenue"}
      title="Monthly Revenue"
      width="w-full"
      height="h-full"
      formatYAxisTick={(val) => `$ ${val}`}
      barChartProps={{
        steps: 5,
        depth: 400,
      }}
      areaChartProps={{
        steps: 5,
        depth: 400,
        renderToolTip: (data) => renderTooltip(data),
      }}
    />
  );
};

export default AreaChartList;
